<template>
<div>
  <el-dialog  title="创建运单" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="ZPflag" width="900px" center>
    <div  style="padding:12px" v-if="goodsYn==1">
      <div style="margin-bottom:20px">
        <div class="box2">
          <p style="color:#409EFF">订单号：{{rowData.orderNo}}</p>
        </div>
        <div class="box1">
          <p>流向：{{rowData.startDirection}}——{{rowData.endDirection}}</p>
          <p>结算客户：{{rowData.payee}}</p>
          <div style="text-align: right;">合计：
            <span v-if="goodform.allWeightT"><span class="red">{{goodform.allWeightT}}</span>吨</span>
            <span v-if="goodform.allWeightT&&(goodform.allNumber||goodform.allVolumn)">/</span>
            <span v-if="goodform.allNumber"><span class="red">{{goodform.allNumber}}</span>件</span>
            <span v-if="goodform.allNumber&&goodform.allVolumn">/</span>
            <span v-if="goodform.allVolumn"><span class="red">{{goodform.allVolumn}}</span>方</span>
          </div>
        </div>
        <el-table height="200px" size="mini" ref="tabref" :data="goodList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>

          <el-table-column property="productTypeName"  width="100" label="货物类型">
             <template >
              <div>
                {{rowData.productTypeName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
            min-width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
            min-width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
            min-width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
            min-width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
            min-width="100"></el-table-column>
        </el-table>
      </div>
    </div>
    <div v-else style="display: flex;">
      <div class="box1">
        <p style="color:#409EFF">订单号：{{rowData.orderNo}}</p>
        <p>始发流向：{{rowData.startDirection}}</p>
      </div>
      <div class="box1">
       <p>结算客户：{{rowData.payee}}</p>
       <p>目的流向：{{rowData.endDirection}}</p>
      </div>
      <div class="box1">
        <p>剩余量：
          <span v-if="goodform.allWeightT"><span class="red">{{goodform.allWeightT}}</span>吨</span>
          <span v-if="goodform.allWeightT&&(goodform.allNumber||goodform.allVolumn)">/</span>
          <span v-if="goodform.allNumber"><span class="red">{{goodform.allNumber}}</span>件</span>
          <span v-if="goodform.allNumber&&goodform.allVolumn">/</span>
          <span v-if="goodform.allVolumn"><span class="red">{{goodform.allVolumn}}</span>方</span>
        </p>
      </div>
    </div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
      <!-- 车辆信息组件 -->
      <peiche :goodform="goodform"></peiche>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button  @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="saveFn">提交</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import peiche from '@/views/newTMS/publicFiles/wayAndOrder/peiche.vue'
import { findAssignmentGoods, cargoStowage, noCargoStowage } from '@/api/newTMS'
export default {
  name: 'zhipaiyouhuo',
  components: {
    peiche
  },
  props: {
    ZPflag: {
      type: Boolean,
      default: false
    },
    rowDataList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      goodform: { allWeight: 0 },
      rules: {
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ]
      },
      rowData: this.rowDataList[0],
      goodsYn: this.rowDataList[0].goodsYn,
      goodList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.$set(this.goodform, 'measuringUnit', this.rowData.measuringUnit)
    if (this.goodsYn == 1) {
      findAssignmentGoods({ orderId: this.rowData.orderId }).then(res => {
        this.goodList = res
        this.$forceUpdate()
      })
    }
    this.$set(this.goodform, 'allWeightT', this.rowData.residualWeight)
    this.$set(this.goodform, 'allNumber', this.rowData.residualNumber)
    this.$set(this.goodform, 'allVolumn', this.rowData.residualVolumn)
    if (this.goodform.measuringUnit == '吨') {
      this.$set(this.goodform, 'allWeight', this.goodform.allWeightT)
    } else if (this.goodform.measuringUnit == '件') {
      this.$set(this.goodform, 'allWeight', this.goodform.allNumber)
    } else if (this.goodform.measuringUnit == '方') {
      this.$set(this.goodform, 'allWeight', this.goodform.allVolumn)
    }
  },
  methods: {
    // 保存
    saveFn (n) {
      if (!this.goodform.generalTaxId && !this.goodform.driverId) {
        this.$alert('请选择司机', '系统提示')
        return false
      }
      if (!this.goodform.generalTaxId && !this.goodform.plateNumber) {
        this.$alert('请选择车辆', '系统提示')
        return false
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
          }
          // 后台是用payee接收的 再重新赋值一下
          this.$set(this.goodform, 'payee', this.goodform.payer)
          this.$set(this.goodform, 'payeeTaxId', this.goodform.payerTaxId)
          if (this.goodsYn == 1) { // 有货
            let arr = []
            let goodArr = []
            this.goodList.forEach(item1 => {
              goodArr.push(item1.orderGoodsRelId)
            })
            arr.push({
              orderBusinessId: this.rowData.orderBusinessId,
              orderGoodsRelId: goodArr
            })
            this.goodform.stowageOrderList = arr
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            cargoStowage(this.goodform).then(res => {
              loading.close()
              this.$emit('update:ZPflag', false)
              this.$parent.searchFn()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            let arr = []
            let call = 0
            if (this.rowData.measuringUnit == '吨') {
              call = this.rowData.residualWeight
            } else if (this.rowData.measuringUnit == '件') {
              call = this.rowData.residualNumber
            } else if (this.rowData.measuringUnit == '方') {
              call = this.rowData.residualVolumn
            }
            console.log(call)
            arr.push({
              orderBusinessId: this.rowData.orderBusinessId,
              callVolume: call,
              weight: this.rowData.residualWeight,
              number: this.rowData.residualNumber,
              volumn: this.rowData.residualVolumn
            })
            this.goodform.stowageOrderList = arr
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            noCargoStowage(this.goodform).then(res => {
              loading.close()
              this.$emit('update:ZPflag', false)
              this.$parent.searchFn()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },

    getAllXuanGoodFn () {
      let arr = []
      if (this.xuanList.length != 0) {
        this.xuanList.forEach(item => {
          arr = arr.concat(item.detailsData)
        })
      }
      console.log(this.allXuanGood)
      this.allXuanGood = arr
      this.goodform.allWeight = 0
      this.allXuanGood.forEach(item => {
        this.goodform.allWeight = (this.goodform.allWeight * 1000 + item.weight * 1000) / 1000
      })
    },
    closeDialog () {
      this.$emit('update:ZPflag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.box1{
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  p{
    margin-right: 20px;
    margin-top: 0;
  }
}

/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 6px 0 !important;
}
</style>
